/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from '@module-logger/mbp';
import restClient from '../../../app/helpers/restClient';
import { getGuestUserAccessToken } from '../../../state/ducks/Member/ducks/Auth/Plugin/auth/guest';

export const endConversation = async (jwt, conversationId, isCSPEnabled) => {
    try {
        const freshToken = await getGuestUserAccessToken() || jwt;
        const resourcePage = isCSPEnabled ? 'csp/webchat/end-conversation' : 'conversational/garden-webchat-api/webchat/end-conversation';
        const response = await restClient.postFacade({ rootUri: '/' }, resourcePage, freshToken, { conversationId });
        delete response.headers;
        delete response.request;
        delete response.config;
        return response;
    } catch (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            errorMessage: error,
            message: `Webchat: Could not end conversation - id: ${conversationId} - ERROR: ${error}`,
            conversationId,
        });
        return false;
    }
};

export default {};
